<template>
    <div>
        <div class="product-center" >
            <div class="reason" v-for="(item,index) in pages"  :key="index">
                <div class="product-top" v-if="item[0] != null">
                    <div class="product-info">
                        <div class="left">
                            <h3><i class="iconfont icon-yousanjiaoxing"></i>{{item[0].title}}</h3>
                            <ul>
                                <li v-for="(image, index) in item[0].images" :key="index"><img :src="$imgUrl+image" alt=""></li>
                            </ul>
                        </div>
                        <div class="right">
                            <h3><i class="iconfont icon-yousanjiaoxing"></i>功能模块</h3>
                            <div class="product-top-swiper-container">
                                <div class="swiper-wrapper" ref="topSwiperRef">
                                    <div class="swiper-slide" v-for="(fun,index) in item[0].name"  :key="index" @mouseenter="active(index,1)" @mouseleave="active(index,2)">
                                        <h3>{{fun}}</h3>
                                        <p>{{item[0].account[index]}}</p>
                                    </div>
                                </div>
                                <div class="swiper-pagination"></div>
                            </div>
                        </div>
                    </div>
                    <div class="cases"  v-if="item[0].case[0]||item[0].case[1]">
                        <h3><i class="iconfont icon-yousanjiaoxing"></i>案例</h3>
                        <ul>
                            <li v-for="(xg_case, index) in item[0].case" :key="index" v-if="xg_case">
                                <div class="date">
                                    <span>{{getMonth(xg_case.update_time)}}<br><i>&nbsp;/&nbsp;</i><br>{{getDay(xg_case.update_time)}}</span>
                                    <span>{{getYear(xg_case.update_time)}}</span>
                                </div>
                                <div class="img">
                                    <img :src="$imgUrl+xg_case.photo" alt="">
                                    <h4>{{xg_case.title}}</h4>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="product-bottom" v-if="item[1] != null">
                    <h2>产品中心</h2>
                    <div class="product-info">
                        <div class="left">
                            <h3><i class="iconfont icon-yousanjiaoxing"></i>{{item[1].title}}</h3>
                            <ul>
                                <li v-for="(image,index) in item[1].images"  :key="index"><img :src="$imgUrl+image" alt=""></li>
                            </ul>
                        </div>
                        <div class="right">
                            <h3><i class="iconfont icon-yousanjiaoxing"></i>功能模块</h3>
                            <div class="product-bottom-swiper-container">
                                <div class="swiper-wrapper">
                                    <div class="swiper-slide" v-for="(fun,index) in item[1].name" :key="index">
                                        <h3>{{fun}}</h3>
                                        <p>{{item[1].account[index]}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="swiper-controller">
                                <div class="swiper-swiper-prev"><i class="iconfont icon-jiantouzuo"></i></div>
                                <span>|</span>
                                <div class="swiper-swiper-next"><i class="iconfont icon-icon_arrow_right"></i></div>
                            </div>
                        </div>
                    </div>
                    <div class="cases" v-if="item[1].case[0]||item[1].case[1]">
                        <h3><i class="iconfont icon-yousanjiaoxing"></i>案例</h3>
                        <ul>
                            <li v-for="xg_case in item[1].case" v-if="xg_case">
                                <div class="img">
                                    <img :src="$imgUrl+xg_case.photo" alt="">
                                </div>
                                <h4>{{xg_case.title}}</h4>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper from 'swiper'
export default {
    name: 'productCenter',
    props: {
        product: Array,
    },
    mounted () {
        // this.imgSwiper1('.product-top-swiper-container')
        // this.imgSwiper2('.product-bottom-swiper-container','.swiper-swiper-prev','.swiper-swiper-next','my-button-disabled')
    },
    data () {
        return {
            actIndex: 0,
            enterIndex: -1,
            productData: [],
            productArr: {},
        }
    },
    methods: {
        productType (type,index) {
            if(type == null){
                this.productData = this.productArr.all
                this.actIndex = 0
            }else{
                this.productData = this.productArr[type]
                this.actIndex = index
            }
        },
        imgSwiper1 (swiperCN) {
            // console.log(3333)
            let swiper = new Swiper(swiperCN, {
                initialSlide: 0,
                slidesPerView: 4,
                direction: 'vertical',
                slideToClickedSlide: true,
                roundLengths : true, 
                observer: true,//修改swiper自己或子元素时，自动初始化swiper
                observeParents: true,//修改swiper的父元素时，自动初始化swiper
                observeSlideChildren: true,
                virtual: true,
                // forceToAxis: true,
                // onSlideChangeEnd: function(swiper){
                //     mySwiper.startAutoplay();
                //     mySwiper.reLoop();
                //     console.log(444444)
                // }
            });
            swiper.virtual.update()
            // console.log()
        },
        imgSwiper2 (swiperCN,buttomPrev,buttomNext,disabledButtomCN) {
            let swiper = new Swiper(swiperCN, {
                slidesPerView: 5,
                roundLengths : true, 
                slideToClickedSlide: true,
                navigation: {
                    nextEl: buttomNext,
                    prevEl: buttomPrev,
                    disabledClass: disabledButtomCN,
                },
                observer:true,//修改swiper自己或子元素时，自动初始化swiper
                observeParents:true,//修改swiper的父元素时，自动初始化swiper
                observeSlideChildren:true,
                onSlideChangeEnd: function(swiper){
                    swiper.update();  
                    mySwiper.startAutoplay();
                    mySwiper.reLoop();  
                }
            });
        },
        newsDetail (newsId) {
            this.$router.push('/newsdetail/'+newsId)
        },
        active (index,flag) {
            const el = this.$refs.topSwiperRef
            if(flag === 1){
                // el.getElementsByClassName('.swiper-slide')[index].classList.add('active')
            }else{
                // el.getElementsByClassName('.swiper-slide')[index].classList.remove('active')
                // el.getElementsByClassName('.active')[0].classList.remove('active')
            }
            
            
        },
        getYear (time) {
            var  date = new Date(time * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear();
            return Y;
        },
        getMonth (time) {
            var  date = new Date(time * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1);
            return M;
        },
        getDay (time) {
            var  date = new Date(time * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var D = date.getDate();
            return D;
        }
    },
    computed: {
        pages () {
            if(!this.productData){
                return []
            }
            const pages = []
            this.productData.forEach((item,index)=>{
                const page = Math.floor(index/2);
                if(!pages[page])
                    pages[page] = []
                pages[page].push(item)
            })
            // console.log(pages)
            return pages
        }
    },
    watch: {
        product (newVal) {
            // console.log(newVal)
            this.productData = newVal
        }
    }
}
</script>

<style lang="stylus" scoped>
    @import '~styles/varible.styl'
    @import '~styles/mixins.styl'
    .product-center
        max-width: 1920px
        min-width: 1600px
        margin: 0 auto
        .iconfont
            font-size: 12px
            vertical-align: bottom
            line-height: 20px
            margin-right: 6px
        .product-top
            background: url("../../static/images/product_top.png")
            background-size: cover
            padding-bottom: 9%
            .product-info
                position: relative
                width: 60%
                margin: 0 auto
                &:after
                    content:''
                    display: block
                    clear:both
                .left
                    float: left
                    width: 62%
                    h3
                        font-weight: normal
                        font-size: 24px
                        margin: 50px 0 24px
                        letter-spacing: 1px
                        color: #000
                    ul
                        >li
                            position: relative
                            float: left
                            width: 49%
                            margin-bottom: 1px
                            padding-top: 33.6%
                            overflow: hidden
                            box-sizing: border-box
                            img
                                position: absolute
                                float: left
                                top: 0
                                left: 0
                                width: 100%
                        >li:nth-of-type(2n+1)
                            margin-right: 1px
                .right
                    position: absolute
                    top: -4px
                    bottom: 0
                    right: 0
                    width: 33%
                    min-width: 360px
                    margin-top: -20px
                    background: #353535
                    &:after
                        position: absolute
                        display: block
                        content: ''
                        width: 15%
                        bottom: 20px
                        left: 50%
                        margin-left: -7.5%
                        border-bottom: 1px solid #999
                    >h3
                        position: absolute
                        font-weight: normal
                        font-size: 22px
                        letter-spacing: 1px
                        top: 15%
                        padding-left: 8%
                        color: $yellow
                    .product-top-swiper-container
                        position: absolute
                        top: 23%
                        width: 100%
                        height: 380px
                        overflow: hidden
                        .swiper-wrapper
                            height: 100%
                            .swiper-slide
                                height: 25%
                                padding: 2% 8% 2%
                                box-sizing: border-box
                                color: #fff
                                h3
                                    font-size: 18px
                                    font-weight: 400
                                    line-height: 32px
                                    letter-spacing: 1px
                                p
                                    font-size: 14px
                                    line-height: 1.6em
                                    font-family: MicrosoftYaHei
                            .active,.swiper-slide:first-of-type
                                background: $yellow
                                color: #333
            .cases
                width: 60%
                margin: 0 auto
                &:after
                    content:''
                    display: block
                    clear:both
                h3
                    font-weight: 600
                    font-size: 20px
                    margin: 3em 0 1.2em
                ul
                    >li
                        position: relative
                        float: left
                        box-sizing: border-box
                        width: 48.5%
                        padding: 2% 2% 0 2%
                        background: $black
                        .date
                            text-align: right
                            width: 4%
                            color: #fff
                            padding: 14% 0 16% 0
                            span:first-of-type
                                font-size: 26px
                                font-weight: 600
                                i
                                    font-style: italic
                            span:last-of-type
                                font-size:12px
                                font-weight: 600
                        .img
                            position: absolute
                            top: 6%
                            right: 3%
                            width: 85%
                            img
                                width: 100%
                            h4
                                margin-left: 30%
                                font-size: 20px
                                font-weight: 600
                                line-height: 3.6em
                                color: $black
                    >li:first-of-type
                        margin-right: 3%   
        .product-bottom
            background: url("../../static/images/product_bottom.png")
            background-size: cover
            background-repeat: no-repeat
            padding-bottom: 8%
            h2
                font-size: 42px
                font-weight: 600
                color: #333
                padding: 4.8% 0 4.8% 35%
                letter-spacing: 2px
            .product-info
                position: relative
                width: 100%
                padding-bottom: 39%
                .left
                    position: absolute
                    z-index: 2
                    top: 16%
                    left:0
                    width: 86%
                    h3
                        padding-left: 4%
                        margin-bottom: 7.5%
                        font-size: 24px
                        font-weight: 600
                    >ul
                        width: 100%
                        li
                            float: left
                            width: 22%
                            margin-right: 1.5%
                            img
                                width: 100%
                        li:last-of-type
                            margin-right: 0%
                .right
                    position: absolute
                    box-sizing: border-box
                    width: 60%
                    right: 0
                    padding: 3% 4% 6% 2.5%
                    background: #353535
                    z-index: 1
                    >h3
                        margin-bottom: 6%
                        font-size: 20px
                        font-weight: 600
                        color: $yellow
                    .product-bottom-swiper-container
                        width:100%
                        overflow: hidden
                        box-sizing: border-box
                        .swiper-wrapper
                            width: 100%
                            .swiper-slide
                                width: 20%
                                padding-right: 2%
                                box-sizing: border-box
                                color: #fff
                                h3
                                    font-size: 18px
                                    font-weight: 400
                                    line-height: 32px
                                p
                                    color: #ccc
                                    padding-left: 12%
                                    line-height: 1.4em
                                    font-family: MicrosoftYaHei
                    .swiper-controller
                        position: absolute
                        right: 0
                        bottom: -15px
                        display: inline-block
                        background: #000
                        color: #fff
                        >div
                            display: inline-block
                            padding: 1.4em 2.2em
                            i
                                margin: 0 0.3em
                                font-size: 14px
                                vertical-align: middle
                        .my-button-disabled
                            opacity: 0.3
            .cases
                width: 60%
                margin: 0 auto
                &:after
                    content:''
                    display: block
                    clear:both
                h3
                    font-weight: 600
                    font-size: 20px
                    margin: 0 0 2em
                    text-align: center
                ul
                    >li
                        float: left
                        position: relative
                        box-sizing: border-box
                        width: 47.5%
                        .img
                            padding: 4% 6% 2% 2%
                            background: $black
                            img
                                width: 100%
                                vertical-align: middle
                        h4
                            color: $black
                            margin-left: 30%
                            font-size: 20px
                            font-weight: 600
                            line-height: 2em
                    >li:first-of-type
                        margin-right: 5%  
</style>



// WEBPACK FOOTER //
// src/components/pc/ProductCenter.vue